module.exports = __webpack_public_path__ + "img/9246ca5.png";